<template>
  <h2>ORGANIZATION PAGE</h2>
  <dl>
    <dt v-if="isArtist || isArtistBeforeProfile || isArtistPending || isBusiness">
      <a href="#">CONTEST</a>
    </dt>
    <dd v-if="isArtist || isArtistBeforeProfile || isArtistPending || isBusiness">
      <ul>
        <li
          @click="handleMenuClick('contest')"
          :class="{ on: route.path.startsWith('/organization/contest') }"
        >
          <router-link v-if="!isArtistPending" :to="{ name: 'ContestManage' }"
            >공모전 관리</router-link
          >
          <a v-else href="#">공모전 관리</a>
        </li>
      </ul>
    </dd>
  </dl>
</template>

<script setup>
import { useAuthInfo } from "@/composables/useAuthInfo";
import { useAuthStore } from "@/store/auth.module";
import { useRoute, useRouter } from "vue-router";

const {
  isArtist,
  isArtistBeforeProfile,
  isArtistPending,
  isBusiness,
} = useAuthInfo();

const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();

const handleMenuClick = async (menuType) => {
  await authStore.refreshRoleType();

  // ARTIST 사용자 체크
  if (isArtistPending.value) {
    alert(
      "승인 대기 중이므로 해당 메뉴를 이용할 수 없습니다.\n" +
        "가입 완료 메일 수신 후 이용해 주세요."
    );
    return;
  }

  if (menuType !== "contest" && isArtistBeforeProfile.value) {
    alert("프로필을 먼저 등록해 주세요.");
    await router.push({ name: "MyProfile" });
    return;
  }

  // BUSINESS 사용자는 별도 체크 없이 바로 접근 가능
};
</script>

<style scoped>
</style>
